const hub = {
  quickStats: "Quick Stats",
  totalEntities: "Total Entities",
  docsThisWeek: "Docs This Week",
  openTasks: "Open Tasks",
  aiConversations: "AI Conversations Today",
  recentActivity: "Recent Activity",
  noActivity: "No recent activity",
  biCharts: "Charts",
  statusDistribution: "Status Distribution",
  activityTimeline: "Activity Timeline",
  entityBreakdown: "Entity Breakdown",
  last7Days: "Last 7 Days",
  last30Days: "Last 30 Days",
  quickAccess: "Quick Access",
  openItem: "Open",
  openInSidePanel: "Open in Side Panel",
  duplicate: "Duplicate",
  deleteItem: "Delete",
  addToFavorites: "Add to Favorites",
  removeFromFavorites: "Remove from Favorites",
  copyLink: "Copy Link",
  editIcon: "Edit Icon",
  colorRule: "Color Rule",
  colorRuleTitle: "Color Rule",
  colorRuleField: "Field",
  colorRuleValue: "Value",
  colorRuleColor: "Color",
  colorRuleSave: "Save",
  colorRuleRemove: "Remove Rule",
  linkCopied: "Link copied",
} as const;
export default hub;
